'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _updateChild = require('./updateChild');

var _updateChild2 = _interopRequireDefault(_updateChild);

var _updateChildKeys = require('./updateChildKeys');

var _updateChildKeys2 = _interopRequireDefault(_updateChildKeys);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return function (parcelData) {
        if (parcelData.child) {
            return parcelData;
        }
        return (0, _pipeWith2.default)(parcelData, (0, _updateChild2.default)(), (0, _updateChildKeys2.default)());
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/prepareChildKeys.js
// module id = 240
// module chunks = 35783957827783